import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";

const RateCatalogForm = (props) => {
  var d = new Date();

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [productData, setProductData] = useState([]);

  const offset = currentPage * itemsPerPage;

  const { sendRequest: getProductList } = useHttp();

  const fetchProductData = (itemSubTypeId) => {
    getProductList(
      {
        url: `/api/fillProductListForRateCatalog/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          setProductData(res);
        }
      }
    );
  };
  useEffect(() => {
    fetchProductData();
  }, []);

  const { sendRequest: postSalesRateCard } = useHttp();

  const submitHandler = (e) => {
    console.log("month", d.getMonth() + 1);

    e.preventDefault();

    if (productData.length == 0) {
      toast.error("Product details not found");
      return;
    }

    const data =
      productData &&
      productData.map((item, i) => ({
        salesRateDate: moment(new Date().toISOString().slice(0, 10)).format("DD/MM/YYYY"),
        productId: item.productId,
        salesRate: parseInt(item.salesRate),
        qtyPerHa: parseInt(item.salesRate),
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: parseInt(localStorage.getItem("orgId")),
      }));
    console.log(data);

    postSalesRateCard(
      {
        url: "/api/goodsIssuesalesrate/",

        method: "POST",
        body: data,
      },
      (data) => {
        console.log(data);
        toast.success(`RateCatalog Detail added`);
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    if (props.update) {
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Rate Catalog Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Product Detail </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered table-responsive  text-center">
                      <thead>
                        <tr>
                          <th>Product Item Type </th>
                          <th>Product Item Subtype </th>
                          <th>Product Name </th>
                          <th>Product No </th>
                          <th>Unit </th>

                          <th>Price Per Unit</th>
                          <th>Quantity Per Hector</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productData &&
                          productData.map((x, i) => (
                            <tr key={i}>
                              <td>
                                {x.productTypeName}( {x.productTypeNo})
                              </td>

                              <td>
                                {x.productSubTypeName}({x.productSubType})
                              </td>

                              <td>{x.productName}</td>

                              <td>{x.itemId}</td>

                              <td>{x.unitName}</td>

                              <td>
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="col-md-8">
                                    <input
                                      type={"number"}
                                      id={"PricePerUnit"}
                                      required
                                      className="form-control text-right"
                                      defaultValue={productData[i].salesRate}
                                      onChange={(e) => {
                                        productData[i].salesRate =
                                          e.target.value;
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <input
                                  type={"number"}
                                  id={"qtyPerHa"}
                                  required
                                  className="form-control text-right"
                                  defaultValue={productData[i].qtyPerHa}
                                  onChange={(e) => {
                                    productData[i].qtyPerHa = e.target.value;
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default RateCatalogForm;
